import { Navigate, Outlet } from 'react-router-dom';

import { useAuthContext } from '../../../contexts/AuthContext';
import useSetBackgroundColor from '../../../utils/hooks/useSetBackgroundColor';

export const PublicRoute = ({ redirectPath = '/home' }) => {
    const { userData } = useAuthContext();

    useSetBackgroundColor();

    if (userData) {
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />
}